import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import useFetchAuthMeTemp from '../../customHooks/useFetchAuthMeTemp';
import usePermissions from '../../customHooks/usePermissions';

import ShowEvalResponsableEmpStartNotif from '../../components/ShowEvalResponsableEmpStartNotif/ShowEvalResponsableEmpStartNotif';
import ShouldEvalMyManager from '../../components/ShouldEvalMyManager/ShouldEvalMyManager';
import SuccessNotifiMainPage from '../../components/SuccessNotifiMainPage/SuccessNotifiMainPage';
import NavButtonsComp from '../../components/NavButtonsComp/NavButtonsComp';
import ShowManagerVacationsMainPage from '../../components/ShowManagerVacationsMainPage/ShowManagerVacationsMainPage';
import ShowManagerEvalNofication from '../../components/ShowManagerEvalNofication/ShowManagerEvalNofication';
import HealthIncNotificationToAddRelativeMain from '../../components/HealthInsuranceComps/HealthIncNoficaForEmpComps/HealthIncNotificationToAddRelativeMain/HealthIncNotificationToAddRelativeMain';
import HealthIncNotificaForHrToReviewUploadedRelData from '../../components/HealthInsuranceComps/HealthIncNotifica/HealthIncNotificaForHrToReviewUploadedRelData/HealthIncNotificaForHrToReviewUploadedRelData';
import HealthIncNotificaForEmpForReturnedOrRefusedRelativesData from '../../components/HealthInsuranceComps/HealthIncNotifica/HealthIncNotificaForEmpForReturnedOrRefusedRelativesData/HealthIncNotificaForEmpForReturnedOrRefusedRelativesData';
import VacationStatusShow from '../../components/MainPageComps/VacationStatusShow/VacationStatusShow';
import EmpInfoComp from '../../components/MainPageComps/EmpInfoComp/EmpInfoComp';
import DashboardNotifications from '../../components/MainPageComps/DashboardNotifications/DashboardNotifications';

import './main_page.scss';


function MainPage() {
  
    const navigate = useNavigate();

    const location = useLocation();
    
    const successMessage = location.state?.successMessage || null;

    const authMe = useSelector((state) => state.authme.data);
    
    const { checkPermissionAndThrow } = usePermissions();
    const { userPermissions } = usePermissions();

    const { fetchAuthmeTemp , vacationData , should_add_relatives , realativesData , loading , error } = useFetchAuthMeTemp();


//====useEffect start here====

  useEffect(() => {
  if( authMe?.change_password ){
     navigate("/emp/change_pass");
   }
   else{
    fetchAuthmeTemp();
   }
  }, [ ]);


//====useEffect end here==== 
  return (
    <div className='main_page_full'>

     {
      (!authMe.change_password)
      ?
      (
        <div className="main_page_full_container">

        {
          (error) 
            ?
           (<span className='error_mainPage' dir='rtl'>{error}</span>)
            :
           (<></>)
        }


   <DashboardNotifications>

    {
      (successMessage) &&
      (
        <div className='show_notifi_container'>
        <SuccessNotifiMainPage successMessage={successMessage}/>
      </div>    
      )
    }
   
    {
      //show the manager or the emp responsable to eval peoble notifi to eval the peoble
      ( authMe?.is_manager || checkPermissionAndThrow("update_evaluations")
        || checkPermissionAndThrow("hr_manager")
      ) && 
      (
        <div className='show_notifi_container'>
        <ShowManagerEvalNofication/>
        </div>  
      )
    }


      <div className='show_notifi_container'>
        <ShouldEvalMyManager/>
      </div>    

     {
      //the notifi to fire the evaluation system show only to the person who has the permissions 
      ( checkPermissionAndThrow("create_evaluations") || checkPermissionAndThrow("create_manager_evaluations") ) 
      &&
      (
        <div className='show_notifi_container'>
        <ShowEvalResponsableEmpStartNotif/>
        </div>  
      )
     }

    {
      ( should_add_relatives ) &&
      ( <div className='show_notifi_container'> 
        <HealthIncNotificationToAddRelativeMain/>
       </div>)
    }

   {
   ( checkPermissionAndThrow("update_relatives") )  &&
    (<HealthIncNotificaForHrToReviewUploadedRelData />)
    }

    {//for the notifcation to check if there some relative data returned or refused from the hr
      (<HealthIncNotificaForEmpForReturnedOrRefusedRelativesData data = { realativesData } />) 
    }


    {
      (authMe?.is_manager) &&
      (
        <div className='show_manager_emps_vacations'>
        {  
        <ShowManagerVacationsMainPage/>
        }
       </div>
      )
    }
   

    </DashboardNotifications>


{/* the modal for vacation status is here*/}
<VacationStatusShow loading = { loading } vacationData = { vacationData } />


{/*show emp info here*/}
<EmpInfoComp/>
   
   
    {/*for the navivagtion buttons */}
    <NavButtonsComp/>
      

    </div>
      )
      :
      (
        <></>
      )
     } 
    

    </div>
  )
}

export default MainPage;